import { imageWrapperIconDelete } from "../components/imageWrapperIconDelete";
import { handleAjaxError } from "../actions/handleAjaxError";
import { addToFavourites } from "../actions/addToFavourites";
import {
    imageWrapperIconImgToVideo
} from "@growtype-chat/partials/components/imageWrapperIconImgToVideo";

function pageAssistantProfile() {
    const profilePageSelector = '.page-profile, .page-roleplay';
    let premiumFeedObserver = null;
    let premiumFeedFallbackBound = false;
    let premiumFeedMutationObserver = null;

    /**
     * Keep the active conversation preview aligned with the newest rendered
     * assistant turn. The sidebar is server-rendered, so without this update a
     * previous access-gate message remains visible until a full page reload.
     */
    document.addEventListener('typingAnimationComplete', function (event) {
        const message = $(event.detail?.message);
        if (!message.length || message.attr('data-role') !== 'user') {
            return;
        }

        const activeSession = $('.g-chatsessions-single.is-active, .g-chatsessions-single.active').first();
        const preview = activeSession.find('.g-chatsessions-single-content-desc').first();
        const messageText = message.find('.g-chatform-message-content-inner').first().text()
            .replace(/\s+/g, ' ')
            .trim();
        if (!preview.length || !messageText) {
            return;
        }

        preview.text(messageText.length > 40
            ? `${messageText.slice(0, 40)}...`
            : messageText
        );
    });

    $('.growtype-post-avatar .btn-make-private').click(function (event) {
        event.preventDefault();
        let slug = $(this).closest('.growtype-post-single-inner').attr('data-slug')
        let element = $(this)

        $.ajax({
            type: "POST",
            url: window.growtype_child_ajax.url,
            data: {
                action: 'make_character_private',
                character_slug: slug,
            },
            success: function (response) {
                element.removeClass('anim-pulse')
                element.attr('data-status', 'private')
                element.text(element.attr('data-private-text'))
            },
            error: function (response) {
                if (response.responseJSON.data.message === 'subscription_required') {
                    $('#growtypeWcSubscriptionModal').modal('show');
                }
            }
        });
    });

    /**
     * Update image
     */
    $(document).ready(function () {
        imageWrapperIconDelete();

        /**
         * Open sidebar on tablet
         */
        if ($('body').is(profilePageSelector)) {
            if ($(window).width() > 637 && $(window).width() < 1124) {
                $('.g-btn-close-sidebar').click();
            }
        }
    });

    function submitModalFormFields() {
        $('.modal .btn-submit-form-fields').click(function () {
            let submitBtn = $(this);
            let formFields = submitBtn.closest('.modal').find('.growtype-form-fields');

            let formValues = {};
            formFields.find('input, textarea').each(function (element) {
                formValues[$(this).attr('name')] = $(this).val();
            });

            if (submitBtn.hasClass('is-loading') || submitBtn.hasClass('is-disabled')) {
                return;
            }

            submitBtn.addClass('is-loading')

            jQuery.ajax({
                url: growtype_child_ajax.url,
                type: 'post',
                data: {
                    action: 'update_assistant_profile',
                    profile_slug: $(this).attr('data-profile-slug'),
                    form_values: formValues
                },
                success: function (response) {
                    if (response.success) {
                        submitBtn.closest('.modal').modal('hide');
                        location.reload();
                    } else {
                        submitBtn.removeClass('is-loading');
                        handleAjaxError(response);
                    }
                },
                error: function (response) {

                }
            });
        });
    }

    /**
     * Edit profile
     */
    $('.g-chat-btn-edit-profile').click(function (event) {
        event.preventDefault();
        event.stopPropagation();

        let submitBtn = $(this);

        if (submitBtn.hasClass('is-loading') || submitBtn.hasClass('is-disabled')) {
            return;
        }

        submitBtn.addClass('is-loading')

        jQuery.ajax({
            url: growtype_child_ajax.url,
            type: 'post',
            data: {
                profile_slug: submitBtn.attr('data-profile-slug'),
                action: 'edit_assistant_profile',
            },
            success: function (response) {
                $('#' + response.data.modal_id).remove();
                $('body').prepend(response.data.modal_content);
                $('#' + response.data.modal_id).modal('show');
                submitBtn.removeClass('is-loading');

                submitModalFormFields()
            },
            error: function (response) {
                submitBtn.removeClass('is-loading');
                handleAjaxError(response);
            }
        });
    });

    /**
     * Use credits
     */
    document.addEventListener('growtypeChatUseCreditsResponse', function (event) {
        if (event.detail.response.success) {
            if (event.detail.params.reason === "generate_custom_assistant_image" || event.detail.params.reason === "generate_custom_assistant_content") {
                // $('.growtype-post-avatar .btn-make-private').removeClass('anim-pulse')
            }
        }
    });

    /**
     * Gallery
     */
    function updateGalleryVisibility(gallery) {
        if (gallery.hasClass('premium-feed')) {
            return;
        }

        let visibleImagesLimit = window.growtype_child_ajax.custom_gallery_visible_images_limit || 7;
        visibleImagesLimit = parseInt(visibleImagesLimit);

        if ($(window).width() < 768) {
            visibleImagesLimit = visibleImagesLimit - 2;
        }

        if (gallery.attr('data-hidden') === 'true') {
            visibleImagesLimit = window.growtype_child_ajax.custom_gallery_visible_images_limit || 7;
            if ($(window).width() < 768) {
                visibleImagesLimit = visibleImagesLimit - 2;
            }
        }

        const galleryImages = gallery.find('.custom-gallery-image');
        const totalImages = galleryImages.length;

        galleryImages.each(function (index) {
            let galleryItem = $(this);

            if (index === visibleImagesLimit && gallery.attr('data-hidden') !== 'true') {
                galleryItem.find('.b-actions').remove();
                galleryItem.append(`
                <div class="custom-gallery-images-hidden-amount">
                    <div class="custom-gallery-images-hidden-amount-nr">+${totalImages - visibleImagesLimit}</div>
                </div>
            `);
            }

            if (index > visibleImagesLimit) {
                galleryItem.addClass('is-hidden');
            } else {
                galleryItem.removeClass('is-hidden');
            }
        });
    }

    function updateAllGalleries() {
        $(`${profilePageSelector} .custom-gallery`).each(function () {
            updateGalleryVisibility($(this));
        });
    }

    function refreshProfileGalleries(container = document) {
        const scope = container && container.jquery ? container : $(container);

        scope
            .find('.custom-gallery')
            .add(scope.filter('.custom-gallery'))
            .each(function () {
                updateGalleryVisibility($(this));
            });
    }

    updateAllGalleries();

    function getLazySettings(overrides = {}) {
        return {
            scrollDirection: 'vertical',
            effect: 'fadeIn',
            visibleOnly: overrides.visibleOnly ?? true,
            chainable: false,
            threshold: 500,
            onError: function (element) {
                const failedItem = element.closest('.custom-gallery-image');
                if (failedItem.length) {
                    failedItem.remove();
                    updateAllGalleries();
                } else {
                    element.remove();
                }
            }
        };
    }

    function initLazyLoad(container, options = {}) {
        if (!$.fn.Lazy) return;

        var $elements = (container ? $(container).find('.lazy-load[data-src]') : $('.lazy-load[data-src]'));
        if ($elements.length === 0) return;

        // Separate elements by their scroll container
        const $chatContent = $('.g-chatform .g-chatform-content');

        const $chatElements = [];
        const $normalElements = [];

        $elements.each(function () {
            if ($chatContent.length > 0 && $(this).closest('.g-chatform-content').length > 0) {
                $chatElements.push(this);
            } else {
                $normalElements.push(this);
            }
        });

        if ($chatElements.length > 0) {
            let settings = getLazySettings(options);
            settings['appendScroll'] = $chatContent;
            $($chatElements).Lazy(settings);
        }

        if ($normalElements.length > 0) {
            $($normalElements).Lazy(getLazySettings(options));
        }
    }

    /**
     * Premium feed (autoload on scroll)
     */
    function loadPremiumFeedItems(gallery) {
        const profileSlug = gallery.data('profile-slug');
        const offset = parseInt(gallery.data('offset'), 10) || 0;
        const limit = parseInt(gallery.data('limit'), 10) || 5;
        const nonce = gallery.data('nonce');
        let hasMore = gallery.data('has-more');

        const assetType = gallery.data('asset-type') || 'images';

        // Normalize hasMore (could be string or bool)
        if (typeof hasMore === 'string') hasMore = hasMore === 'true';

        if (!profileSlug || gallery.hasClass('is-loading') || hasMore === false) {
            return;
        }

        gallery.addClass('is-loading');

        $.ajax({
            type: 'POST',
            url: window.growtype_child_ajax.url,
            data: {
                action: 'premium_feed_items',
                profile_slug: profileSlug,
                offset: offset,
                limit: limit,
                nonce: nonce,
                type: assetType,
            },
            success: function (response) {
                const sentinel = ensurePremiumFeedSentinel(gallery);
                if (response.success && response.data && response.data.html) {
                    const newItems = $(response.data.html);
                    sentinel.detach();
                    gallery.append(newItems);
                    gallery.append(sentinel);
                    initLazyLoad(gallery);

                    imageWrapperIconImgToVideo(newItems);
                }

                if (!response.success || !response.data || !response.data.has_more) {
                    gallery.data('has-more', false);
                    gallery.removeClass('is-loading');
                    sentinel.remove();

                    if (gallery.find('.premium-feed-end').length === 0) {
                        const message = (response.data && response.data.no_more_items_text) ? response.data.no_more_items_text : 'All items loaded.';
                        gallery.append(`<div class="premium-feed-end text-center w-100 py-4 mt-2 opacity-50 small">${message}</div>`);
                    }
                    return;
                }

                gallery.data('offset', response.data.next_offset);
                gallery.removeClass('is-loading');

                // Immediately check if we need to load more if the screen is still not filled
                setTimeout(() => {
                    const windowHeight = $(window).height();
                    const scrollBottom = $(window).scrollTop() + windowHeight;
                    const galleryBottom = gallery.offset().top + gallery.outerHeight();
                    if (scrollBottom >= galleryBottom - 100) {
                        loadPremiumFeedItems(gallery);
                    }
                }, 100);
            },
            error: function () {
                gallery.removeClass('is-loading');
            }
        });
    }

    function ensurePremiumFeedSentinel(gallery) {
        let sentinel = gallery.children('.premium-feed-sentinel');

        if (!sentinel.length) {
            sentinel = $('<div class="premium-feed-sentinel" aria-hidden="true"></div>');
            gallery.append(sentinel);
        }

        return sentinel;
    }

    function shouldLoadPremiumFeed(gallery) {
        let hasMore = gallery.data('has-more');
        if (typeof hasMore === 'string') hasMore = hasMore === 'true';

        if (!gallery.is(':visible') || gallery.hasClass('is-loading') || hasMore === false) {
            return false;
        }

        const sentinel = ensurePremiumFeedSentinel(gallery);
        const sentinelRect = sentinel[0].getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

        return sentinelRect.top <= viewportHeight + 400;
    }

    function maybeLoadPremiumFeed(gallery) {
        if (shouldLoadPremiumFeed(gallery)) {
            loadPremiumFeedItems(gallery);
        }
    }

    function getPremiumFeedGalleries(container = document) {
        const scope = container && container.jquery ? container : $(container);

        return scope
            .find('.custom-gallery.premium-feed')
            .add(scope.filter('.custom-gallery.premium-feed'));
    }

    function runPremiumFeedChecks(container = document) {
        getPremiumFeedGalleries(container).each(function () {
            maybeLoadPremiumFeed($(this));
        });
    }

    function setupPremiumFeedInfiniteScroll(container = document) {
        const galleries = getPremiumFeedGalleries(container);
        if (!galleries.length) {
            return;
        }

        const supportsIntersectionObserver = typeof window.IntersectionObserver === 'function';

        if (supportsIntersectionObserver) {
            if (!premiumFeedObserver) {
                premiumFeedObserver = new window.IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) {
                            return;
                        }

                        const gallery = $(entry.target).closest('.custom-gallery.premium-feed');
                        maybeLoadPremiumFeed(gallery);
                    });
                }, {
                    root: null,
                    rootMargin: '400px 0px 400px 0px',
                    threshold: 0
                });
            }

            galleries.each(function () {
                const gallery = $(this);
                if (gallery.data('premium-feed-initialized')) {
                    return;
                }

                const sentinel = ensurePremiumFeedSentinel(gallery);
                premiumFeedObserver.observe(sentinel[0]);
                gallery.data('premium-feed-initialized', true);
            });
        } else {
            if (!premiumFeedFallbackBound) {
                const onScroll = function () {
                    runPremiumFeedChecks(document);
                };

                $(window).on('scroll', onScroll);
                $('.tab-content').on('scroll', onScroll);
                premiumFeedFallbackBound = true;
            }
        }

        runPremiumFeedChecks(container);
    }

    function initPremiumFeedInfiniteScroll() {
        setupPremiumFeedInfiniteScroll(document);

        $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
            const targetSelector = $(this).attr('data-bs-target');
            const targetPane = targetSelector ? $(targetSelector) : $();
            refreshProfileGalleries(targetPane);
            initLazyLoad(targetPane, { visibleOnly: false });
            runPremiumFeedChecks(document);
        });

        $(document).ready(() => {
            setTimeout(() => {
                refreshProfileGalleries(document);
                setupPremiumFeedInfiniteScroll(document);
            }, 500);
        });

        if (typeof window.MutationObserver === 'function' && !premiumFeedMutationObserver) {
            premiumFeedMutationObserver = new window.MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (!(node instanceof Element)) {
                            return;
                        }

                        if (
                            node.matches('.custom-gallery.premium-feed') ||
                            node.querySelector('.custom-gallery.premium-feed')
                        ) {
                            setupPremiumFeedInfiniteScroll(node);
                        }
                    });
                });
            });

            premiumFeedMutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        document.addEventListener('growtypeChatProfileContentRendered', function (event) {
            const container = event?.detail?.content || event?.detail?.contentWrapper || document;
            setupPremiumFeedInfiniteScroll(container);

            setTimeout(function () {
                setupPremiumFeedInfiniteScroll(container);
            }, 150);

            setTimeout(function () {
                setupPremiumFeedInfiniteScroll(container);
            }, 350);
        });
    }

    function resolveProfileHashTarget() {
        const hash = (window.location.hash || '').trim();
        if (!hash || hash === '#') {
            return null;
        }

        const normalizedHash = decodeURIComponent(hash);
        let target = null;

        if (normalizedHash.startsWith('#tabs=')) {
            const tabParts = normalizedHash.slice('#tabs='.length).split(':').filter(Boolean);
            const targetId = tabParts.length ? tabParts[tabParts.length - 1] : '';

            if (targetId) {
                target = document.getElementById(targetId);
            }
        } else if (normalizedHash.startsWith('#')) {
            target = document.getElementById(normalizedHash.slice(1));
        }

        if (!target) {
            try {
                target = document.querySelector(normalizedHash);
            } catch (error) {
                return null;
            }
        }

        if (!target) {
            return null;
        }

        const $target = $(target);
        const $section = $target.is('[data-type]')
            ? $target
            : $target.closest('[data-type]');
        const $tabPane = $target.hasClass('tab-pane')
            ? $target
            : $target.closest('.tab-pane');

        return {
            hash,
            $target,
            $section,
            $tabPane
        };
    }

    function normalizePathname(pathname = '') {
        if (!pathname || pathname === '/') {
            return '/';
        }

        return pathname.replace(/\/+$/, '') || '/';
    }

    function resolveSamePageHashUrl(href) {
        if (!href) {
            return null;
        }

        let parsedUrl = null;

        try {
            parsedUrl = new URL(href, window.location.href);
        } catch (error) {
            return null;
        }

        const currentUrl = new URL(window.location.href);
        const isSamePage = parsedUrl.origin === currentUrl.origin
            && normalizePathname(parsedUrl.pathname) === normalizePathname(currentUrl.pathname)
            && parsedUrl.search === currentUrl.search;

        if (!isSamePage || !parsedUrl.hash || parsedUrl.hash === '#') {
            return null;
        }

        return parsedUrl;
    }

    function activateProfileTab($tabPane) {
        if (!$tabPane || !$tabPane.length || !$tabPane.attr('id')) {
            return;
        }

        const selector = '[data-bs-target="#' + $tabPane.attr('id') + '"], [data-target="#' + $tabPane.attr('id') + '"]';
        const $tabButton = $(selector).first();

        if (!$tabButton.length) {
            return;
        }

        if (window.bootstrap && window.bootstrap.Tab) {
            window.bootstrap.Tab.getOrCreateInstance($tabButton[0]).show();
        } else {
            $tabButton.trigger('click');
        }
    }

    function focusProfileHashTarget() {
        if (!$('body').is(profilePageSelector)) {
            return;
        }

        const hashTarget = resolveProfileHashTarget();
        if (!hashTarget) {
            return;
        }

        if (hashTarget.$tabPane && hashTarget.$tabPane.length) {
            activateProfileTab(hashTarget.$tabPane);
        }

        const $scrollTarget = hashTarget.$section && hashTarget.$section.length
            ? hashTarget.$section
            : hashTarget.$target;

        if ($scrollTarget.length && $scrollTarget[0] && typeof $scrollTarget[0].scrollIntoView === 'function') {
            $scrollTarget[0].scrollIntoView({
                behavior: 'auto',
                block: 'start'
            });
        }

        if (hashTarget.$tabPane && hashTarget.$tabPane.length) {
            refreshProfileGalleries(hashTarget.$tabPane);
            initLazyLoad(hashTarget.$tabPane, { visibleOnly: false });
        } else {
            refreshProfileGalleries($scrollTarget);
        }

        runPremiumFeedChecks($scrollTarget);
    }

    $(document).on('click', '.g-chatprofile-premium-preview-card, .g-chatprofile-premium-preview-tile', function (event) {
        const href = $(this).attr('href');
        const hashUrl = resolveSamePageHashUrl(href);
        if (!hashUrl) {
            if (href) {
                event.preventDefault();
                window.location.href = href;
            }
            return;
        }

        event.preventDefault();

        if (window.location.hash !== hashUrl.hash) {
            window.location.hash = hashUrl.hash;
        }

        focusProfileHashTarget();
    });

    initLazyLoad();
    initPremiumFeedInfiniteScroll();
    focusProfileHashTarget();

    $(window).on('hashchange', function () {
        focusProfileHashTarget();
    });

    // Re-init lazy on slick slider changes
    $(document).on('init afterChange', '.growtype-theme-slider', function () {
        initLazyLoad(this);
    });

    $(document).ajaxSuccess(function () {
        refreshProfileGalleries(document);
        initLazyLoad();
        setupPremiumFeedInfiniteScroll(document);
    });

    document.addEventListener('growtypeChatContentRendered', function (event) {
        let container = event?.detail?.contentWrapper || event?.detail?.content || null;
        refreshProfileGalleries(container || document);
        initLazyLoad(container);
        setTimeout(function () {
            refreshProfileGalleries(container || document);
            initLazyLoad(container);
        }, 150);
        setTimeout(function () {
            refreshProfileGalleries(container || document);
            initLazyLoad(container);
        }, 350);
    });

    document.addEventListener('growtypeChatMessageReturnFinished', function () {
        initLazyLoad();
        setTimeout(function () {
            initLazyLoad();
        }, 350);
    });

    document.addEventListener('growtypeChatMessageResponseEvent', function () {
        initLazyLoad();
        setTimeout(function () {
            initLazyLoad();
        }, 350);
    });

    /**
     * Refresh
     */
    $('.btn-refresh').click(function (event) {
        let label = $(this).attr('data-label-refreshing');

        if ($(this).hasClass('is-loading')) {
            event.preventDefault();
        } else {
            $(this).addClass('is-loading');
            $(this).text(label);
        }
    });

    /**
     * Show more
     */
    function profileShowMoreDetails() {
        $('.g-chatprofile-info .g-chatprofile-details-wrapper .btn-showmore').click(function () {
            if (!$(this).closest('.g-chatprofile-details-wrapper').hasClass('is-visible')) {
                $(this).text('Show less details')
            } else {
                $(this).text('Show more details')
            }

            $(this).closest('.g-chatprofile-details-wrapper').toggleClass('is-visible');
            $(this).closest('.g-chatprofile-info').find('.g-chatprofile-description').toggleClass('is-limited');
        });
    }

    /**
     * Check g-chatprofile-photo and remove same photo from g-chatprofile-avatar slider
     */
    function removeDuplicateAvatarPhoto(container) {
        if ($(window).width() >= 1125) {
            return;
        }

        const $container = $(container);
        const $profilePhoto = $container.find(".g-chatprofile-photo [data-image-id]");

        if (!$profilePhoto.length) {
            return;
        }

        const profilePhotoId = $profilePhoto.attr("data-image-id");
        const $avatarSlider = $container.find(".g-chatprofile-avatar .growtype-theme-slider");

        if ($avatarSlider.length) {
            const $duplicatePhotos = $avatarSlider.find(`[data-image-id="${profilePhotoId}"]`);
            if ($duplicatePhotos.length) {
                const $firstDuplicate = $duplicatePhotos.first();
                if ($avatarSlider.hasClass("slick-initialized")) {
                    const slickObj = $avatarSlider.slick('getSlick');
                    if (slickObj && slickObj.slideCount > 1) {
                        const slideIndex = $firstDuplicate.closest(".slick-slide").data("slick-index");
                        $avatarSlider.slick("slickRemove", slideIndex);

                        const remainingSlickObj = $avatarSlider.slick('getSlick');
                        if (remainingSlickObj && remainingSlickObj.slideCount <= 1) {
                            $avatarSlider.slick('unslick');
                        }
                    }
                } else {
                    const slideCount = $avatarSlider.children().length;
                    if (slideCount > 1) {
                        $firstDuplicate.remove();
                        if ($avatarSlider.children().length <= 1) {
                             $avatarSlider.removeClass('growtype-theme-slider slick-initialized slick-slider');
                        }
                    }
                }
            }
        }
    }

    $(".g-chatprofile").each(function () {
        removeDuplicateAvatarPhoto($(this));
    });

    /**
     *
     */
    document.addEventListener('growtypeChatProfileContentRendered', function (event) {
        addToFavourites($(event.detail.content).find('.btn-addtofavourites'));
        profileShowMoreDetails();
        removeDuplicateAvatarPhoto(event.detail.content);
        initLazyLoad(event.detail?.content);
        focusProfileHashTarget();
        setTimeout(function () {
            initLazyLoad(event.detail?.content);
            focusProfileHashTarget();
        }, 350);
    });
}

export { pageAssistantProfile };
